import React from "react";

function PrivacyPolicy() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-16 text-gray-700">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
            <p className="mb-8 leading-relaxed">
                EpiQCase (epiqcase.com) uses the Meta pixel, Stripe Checkout, and Brevo to run this site, take orders, and send the free carry guide. This page describes what those services receive. This site does not create customer accounts.
            </p>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Meta pixel</h2>
                <p className="leading-relaxed mb-3">
                    Pages include the Meta pixel (ID 209661709402667). It sends Meta a PageView when a page loads. The purchase page sends ViewContent when it opens. Clicking or pressing the buy area sends InitiateCheckout once for that page. After Stripe marks an order paid, a Purchase event can be sent from the order confirmation page and from our server through Meta&apos;s Conversions API.
                </p>
                <p className="leading-relaxed">
                    The server Purchase event may include checkout details Stripe returns, such as email, phone, name, and address. Those values are hashed before they are sent. When the Meta cookies <code>_fbp</code> and <code>_fbc</code> are present, they are included and also passed to Stripe as a client reference so the purchase can be matched to the same visit. Meta also receives technical data such as IP address, browser, and the pages you open.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Stripe checkout</h2>
                <p className="leading-relaxed">
                    Orders are paid through Stripe Checkout, either the buy button or the payment link shown beside it. You enter payment details on Stripe, not on this site. We do not store your card number. Stripe emails your receipt. When checkout completes, Stripe notifies our server. If you return to the confirmation page, that page asks our server whether the Stripe session was paid so the browser Purchase event can use the same session id.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Brevo email</h2>
                <p className="leading-relaxed">
                    The free guide form at /guide asks for your email and an optional first name. We send those to Brevo, which saves the contact on the guide list and emails you the guide.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Vercel Analytics</h2>
                <p className="leading-relaxed">
                    The site also loads Vercel Analytics, which counts page views without cookies and without identifying you.
                </p>
            </section>

            <p className="text-sm text-gray-600">Last updated: October 14, 2026.</p>
        </div>
    );
}

export default PrivacyPolicy;
